/**
 * - 1: **Standard** - Resource is either available or not (binary).
 * - 2: **Occupancy** - Availability is reduced by party size.
 * - 3: **Booking** - Availability is reduced by the number of bookings. 
 * - 4: **Time** - Availability is based on specific time blocks or schedules.
 */
export const AvailabilityType = Object.freeze({
    Standard: 1,
    Occupancy: 2,
    Booking: 3,
    Time: 4
});